
      // Catch initialization errors before React loads
      window.addEventListener('error', (event) => {
        if (event.message?.includes('before initialization') || 
            event.message?.includes('Cannot access')) {
          console.error('🔴 Module initialization error detected:', {
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            stack: event.error?.stack
          });
          
          // Detect language (vi or en)
          const isVietnamese = navigator.language.toLowerCase().includes('vi');
          
          // Define clear cache function
          window.handleClearCache = async function() {
            const btn = document.getElementById('clearCacheBtn');
            if (!btn) return;
            
            btn.disabled = true;
            btn.innerHTML = '⏳ ' + (isVietnamese ? 'Đang xóa...' : 'Clearing...');
            
            try {
              if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(cacheNames.map(name => caches.delete(name)));
              }
              localStorage.clear();
              sessionStorage.clear();
              location.reload(true);
            } catch (err) {
              console.error('Failed to clear cache:', err);
              location.reload(true);
            }
          };
          
          // Show user-friendly error with Trade Bot 365 branding
          document.getElementById('root').innerHTML = `
            <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;background:#0f0f0f;color:#ffffff;font-family:'Inter','system-ui',-apple-system,sans-serif;padding:24px;">
              <div style="max-width:600px;width:100%;">
                <div style="text-align:center;margin-bottom:32px;animation:fadeIn 0.5s ease-out;">
                  <img 
                    src="https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl//logo%20trade%20bot%20365.png"
                    alt="Trade Bot 365"
                    style="height:64px;width:auto;display:inline-block;"
                    onerror="this.style.display='none'"
                  />
                </div>
                
                <div style="background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:40px;box-shadow:0 20px 60px rgba(0,0,0,0.4);backdrop-filter:blur(10px);animation:slideUp 0.5s ease-out;">
                  <div style="text-align:center;margin-bottom:24px;">
                    <div style="display:inline-flex;align-items:center;justify-content:center;width:80px;height:80px;border-radius:50%;background:rgba(239,68,68,0.1);animation:pulse 2s infinite;">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                      </svg>
                    </div>
                  </div>
                  
                  <h1 style="font-size:28px;font-weight:700;text-align:center;margin:0 0 16px 0;color:#ffffff;">
                    ${isVietnamese ? 'Lỗi Tải Ứng Dụng' : 'Loading Error'}
                  </h1>
                  
                  <p style="font-size:16px;line-height:1.6;text-align:center;color:#9ca3af;margin:0 0 12px 0;">
                    ${isVietnamese 
                      ? 'Ứng dụng gặp lỗi khi khởi động. Thường do cache trình duyệt hoặc phiên bản cũ.' 
                      : 'The app encountered an initialization error. This is usually caused by browser cache or an outdated version.'}
                  </p>
                  
                  <p style="font-size:14px;text-align:center;color:#6b7280;margin:0 0 32px 0;font-style:italic;">
                    💡 ${isVietnamese ? 'Thử xóa cache để khắc phục.' : 'Try clearing your cache to fix this issue.'}
                  </p>
                  
                  <div style="display:flex;gap:12px;flex-direction:column;">
                    <button 
                      onclick="location.reload(true)" 
                      style="background:#22c55e;color:#ffffff;padding:14px 24px;border:none;border-radius:8px;cursor:pointer;font-size:16px;font-weight:600;width:100%;transition:all 0.2s;box-shadow:0 4px 12px rgba(34,197,94,0.3);"
                      onmouseover="this.style.background='#16a34a';this.style.transform='translateY(-2px)';this.style.boxShadow='0 6px 16px rgba(34,197,94,0.4)';"
                      onmouseout="this.style.background='#22c55e';this.style.transform='translateY(0)';this.style.boxShadow='0 4px 12px rgba(34,197,94,0.3)';"
                    >
                      🔄 ${isVietnamese ? 'Tải Lại Trang' : 'Reload Page'}
                    </button>
                    
                    <button 
                      onclick="window.handleClearCache()" 
                      id="clearCacheBtn"
                      style="background:#ef4444;color:#ffffff;padding:14px 24px;border:none;border-radius:8px;cursor:pointer;font-size:16px;font-weight:600;width:100%;transition:all 0.2s;box-shadow:0 4px 12px rgba(239,68,68,0.3);"
                      onmouseover="this.style.background='#dc2626';this.style.transform='translateY(-2px)';this.style.boxShadow='0 6px 16px rgba(239,68,68,0.4)';"
                      onmouseout="this.style.background='#ef4444';this.style.transform='translateY(0)';this.style.boxShadow='0 4px 12px rgba(239,68,68,0.3)';"
                    >
                      🗑️ ${isVietnamese ? 'Xóa Cache & Tải Lại' : 'Clear Cache & Reload'}
                    </button>
                  </div>
                </div>
                
                <div style="text-align:center;margin-top:24px;color:#6b7280;font-size:14px;animation:fadeIn 0.5s ease-out 0.3s backwards;">
                  ${isVietnamese 
                    ? 'Nếu vấn đề vẫn tiếp diễn, vui lòng liên hệ bộ phận hỗ trợ.' 
                    : 'If the problem persists, please contact support.'}
                </div>
              </div>
            </div>
            
            <style>
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              
              @keyframes slideUp {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
              }
              
              @keyframes pulse {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.5; }
              }
            </style>
          `;
          
          event.preventDefault();
        }
      });
    